module.exports = __webpack_public_path__ + "img/home-btn-fb.4bfc876c.svg";